import { TDocumentDefinitions } from 'pdfmake/interfaces';

export async function generateBrowserPdf(documentDefinitions: TDocumentDefinitions) {
  const pdfMake = await import('pdfmake/build/pdfmake');
  const pdfFonts = await import('pdfmake/build/vfs_fonts');

  return pdfMake.createPdf(documentDefinitions, undefined, undefined, pdfFonts.vfs);
}
